export default __webpack_public_path__ + "static/media/heroku.8fcef77c.svg";